import { render, staticRenderFns } from "./EmptyResult.vue?vue&type=template&id=3eb2d4ef"
import script from "./EmptyResult.vue?vue&type=script&lang=js"
export * from "./EmptyResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseProduct: require('/home/korzinka/www/front/components/base/Product.vue').default})
